import React from 'react';
import { connect } from 'react-redux';
import { MultiSelect } from '@blueprintnyc/bpnyc-common-admin';
const GroupSelector = props => {
	const { value, onChange, groups } = props;
	const selectedGroups = value || [];

	const handleDelete = id => {
		if (id && onChange) {
			onChange([...selectedGroups].filter(record => record !== id));
		}
	};

	const handleAdd = id => {
		if (id && onChange) {
			onChange([...selectedGroups, id]);
		}
	};

	return (
		<div className="LeaderboardTeams">
			<MultiSelect
				selected={selectedGroups}
				allOptions={groups}
				onDelete={handleDelete}
				onAdd={handleAdd}
				placeholder="Group"
			/>
		</div>
	);
};

const msp = () => ({});

export default connect(msp)(GroupSelector);
